import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastTabHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/triggering_details',
)({
  component: JourneysBroadcastTabHandoff,
});
